import React, { useState, useEffect } from "react";
import { Alert, Container, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarDashboard from "../../../components/SidebarDashboard";
import { getFuncNodesEmployee } from "../../../redux/funcionalstructure/actions";
import OrgChart from "../../../components/OrgChart";
import { getAuth } from "../../../redux/auth/actions";

const FuncEmployeedStructure = (props) => {
  //Redux
  const dispatch = useDispatch();
  const structure = useSelector((store) => store.funcStructure.astructures);
  const data = useSelector((store) => store.funcStructure.structures);
  const loading = useSelector((store) => store.funcStructure.loading);
  const userRoles = useSelector((store) => store.auth.userRoles);
  //Métodos
  useEffect(() => {
    dispatch(
      getFuncNodesEmployee(
        props.match.params.id,
        parseInt(props.match.params.type)
      )
    );
    dispatch(getAuth());
  }, [dispatch, props.match.params.id, props.match.params.type]);

  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);
  const onNodeClick = (nodeId) => {
    //*String(userRoles[0]).toLowerCase() !== 'empleado'
    if (userRoles.indexOf("empleado") === -1) {
      const { empleados, equipo } = data;
      const employeeNode = empleados.find((item) => `emp${item.id}` === nodeId);
      if (employeeNode) {
        props.history.push(
          `/detalle-empleado/${String(nodeId).substring(
            3,
            String(nodeId).length
          )}/${props.match.params.type}`
        );
      } else {
        const teamNode = equipo.find((item) => `uni${item.id}` === nodeId);
        if (teamNode) {
          props.history.push(
            `/estructura-unidad/${String(nodeId).substring(
              3,
              String(nodeId).length
            )}/${teamNode.nombre}/${props.match.params.type}`
          );
        }
      }
    }
  };

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid style={{ overflow: "hidden" }}>
          {/* <div className="mb-4 mt-2">
            <h5 className="font-weight-bold text-uppercase">
              {props.match.params.unidad.replace("-", "/")}
            </h5>
            <hr />
          </div> */}
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : structure.length > 0 ? (
            <OrgChart
              data={structure}
              onNodeClick={onNodeClick}
              name={props.match.params.unidad.replace("-", "/")}
            />
          ) : (
            <Alert className="my-4" variant="info">
              Esta unidad no tiene elementos que mostrar
            </Alert>
          )}
        </Container>
      </div>
    </>
  );
};

export default FuncEmployeedStructure;
